@for (row of rows(); track row.id; let i = $index) {
  <a
    company-tree-row
    [row]="row"
    (selectCompany)="onSelect($event)"
    (toggleExpand)="onToggle($event)"
    (retry)="onRetry($event)"
  ></a>
  @for (parentId of sentinelParentIds(i); track parentId) {
    <div
      class="company-tree__sentinel"
      role="none"
      aria-hidden="true"
      [loadMoreSentinel]="scrollRoot()"
      (loadMore)="onLoadMore(parentId)"
    ></div>
  }
}
